import React from "react"
import { useSpring, animated } from "react-spring"

import styled from "styled-components"

import { spacing, borderRadius, colors } from "@izettle/otto"

type ProgressBarProps = {
  value: number
  className?: string
}

const Container = styled.div`
  max-width: 175px;
  min-width: 100px;
  margin: 0 auto;
  height: ${spacing.xxSmall};
  border-radius: ${borderRadius.small};
  background-color: ${colors.background.groupedSecondary};
`

const AnimatedFiller = styled(animated.div)`
  height: 100%;
  background-color: ${colors.border.action};
  border-radius: ${borderRadius.small};
  user-select: none;
`

export const ProgressBar: React.FC<ProgressBarProps> = ({ value, className }) => {
  const fillerStyle = useSpring({
    to: { width: `${value}%` },
    config: {
      friction: 15,
      clamp: true,
    },
  })

  return (
    <Container className={className}>
      <AnimatedFiller style={fillerStyle}>&nbsp;</AnimatedFiller>
    </Container>
  )
}
